import React, { useEffect } from "react";
import "./Dashboard.css";
import { Typography, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import stats_img_two from '../../images/db-img-second.png';
import graph_img from '../../images/graph-img.png';
import { fetchDashboardCountAssociate } from "../../Services/dashboarCountAssociate/associateDashboarCountApi";

function DashboardpageComp() {
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const { data } = useSelector((state) => state.fetchDashboardCountAssociate)
  const firstname = localStorage.getItem('user_first_name')

  useEffect(() => {
    dispatch(fetchDashboardCountAssociate(userId)).unwrap();
  }, [dispatch, userId]);


  return (
    <div className="dashboard-section-main">
      <div className="dashboard-section-wrapper">
        <div className="dashboard-section-inner">
          <div className="dashboard-title-filter mb-4 d-flex align-items-center justify-content-between">
            <div className="title-db">
              Hello {firstname}!{" "}
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="30"
                  height="27"
                  x="0"
                  y="0"
                  viewBox="0 0 495.99 495.99"
                  style={{ enableBackground: "new 0 0 512 512" }}
                  xmlSpace="preserve"
                >
                  <g>
                    <path
                      d="M177.801 289.54c16.08 0 29.16-13.08 29.16-29.16v-90.84c0-16.08-13.08-29.16-29.16-29.16s-29.17 13.08-29.17 29.16v90.84c0 16.08 13.09 29.16 29.17 29.16zM107.601 297.801c13.81 0 25.03-11.23 25.03-25.04v-74.32c0-13.8-11.22-25.03-25.03-25.03-13.8 0-25.03 11.23-25.03 25.03v74.32c0 13.81 11.23 25.04 25.03 25.04zM194.811 127.71c16.5 6.73 28.15 22.95 28.15 41.83v30.67c5.414-2.013 4.418-1.51 51.25-1.51l-47.45-177.09c-4.17-15.53-20.19-24.78-35.71-20.61-15.512 4.146-24.815 20.054-20.63 35.71zM409.501 29.76c-12.9-22.293-46.671-18.121-53.43 7.05l-43.38 161.89c20.119 0 36.031 6.571 48.73 19.27l5.13 5.13 45.86-171.2c2.02-7.53.98-15.39-2.91-22.14z"
                      fill="#f7b610"
                      opacity="1"
                    />
                    <path
                      d="M370.211 249.39c-6.911-6.911-2.854-2.856-20.11-20.1-9.4-9.41-21.91-14.59-35.21-14.59h-83.42c-4.622 0-8.51 3.707-8.51 8.52 0 27.46 22.34 49.8 49.8 49.8 44.566 0 42.486-.394 45.01 1.05 4.458 2.74 12.54 16.833 12.54 32.82 0 4.01-2.97 7.4-6.94 7.93-57.25 7.63-100.41 57-100.41 114.85 0 4.42-3.58 8-8 8s-8-3.58-8-8c0-63.26 45.36-117.62 106.72-129.47a35.206 35.206 0 0 0-4.19-11.18h-36.73c-20.05 0-38.04-9.02-50.12-23.21-4.583 37.954-51.994 53.644-78.2 25-11.438 23.304-41.348 30.294-61.87 14.45v62.47c0 70.72 57.54 128.26 128.26 128.26h57.81c70.72 0 128.25-57.54 128.25-128.26v-53.92c0-24.949-10.16-47.9-26.68-64.42z"
                      fill="#f7b610"
                      opacity="1"
                    />
                  </g>
                </svg>
              </span>
            </div>
            {/* <div className="dropdown db-dropdown">
                <div
                  className="dropdown-toggle d-flex justify-content-between dropdown-main"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="dd-menu">Dropdown Menu</div>
                  <div className="vertical-line-dd"></div>
                  <div className="filter-icon-block">
                    <img src={filter_icon} alt="filter-icon"></img>
                  </div>
                </div>
                <ul
                  className="dropdown-menu dd-menu-main"
                  aria-labelledby="dropdownMenuButton"
                >
                  <li>
                    <a className="dropdown-item" href="#action1">
                      Last 30 days
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#action2">
                      Last 20 days
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#action3">
                      Last 10 days
                    </a>
                  </li>
                </ul>
              </div> */}
          </div>
          <div className="main-dashboard-innerwrapper">
            <div className="row">
              <div className="col-md-4 db-left-content">
                <div className="main-content-inner">
                  <div className="profession-block d-flex justify-content-between">
                    <div className="total-communities order-1">
                      <div className="tc-title">
                        Total Communities <span>{data?.data?.total_community_associate || 0}</span>
                      </div>
                      <div className="detail-btn text-start">
                        <button className="orange-filled-btn claimbtn">Details</button>
                      </div>
                      {/* <div className="tc-units-score d-flex gap-3">
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle orange-shade"></div>
                            <div className="score-details">
                              700 <span>ICP Score Wise</span>
                            </div>
                          </div>
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle gray-shade"></div>
                            <div className="score-details">
                              700 <span>Industry Wise</span>
                            </div>
                          </div>
                          <div></div>
                        </div> */}
                    </div>
                    <div className="tc-img order-2">
                      <img src={stats_img_two} alt="stats-img"></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 db-right-content">
                <div className="main-content-inner">
                  <div className="profession-block d-flex justify-content-between">
                    <div className="total-communities order-1">
                      <div className="tc-title">
                        Lorem Ipsum <span>1000</span>
                      </div>
                      <div className="detail-btn text-start">
                        <button className="orange-filled-btn claimbtn">Details</button>
                      </div>
                      {/* <div className="tc-units-score d-flex gap-3">
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle orange-shade"></div>
                            <div className="score-details">
                              700 <span>Designation Wise</span>
                            </div>
                          </div>
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle gray-shade"></div>
                            <div className="score-details">
                              700 <span>Industry Wise</span>
                            </div>
                          </div>
                          <div></div>
                        </div> */}
                    </div>
                    <div className="tc-img order-2">
                      <img src={stats_img_two} alt="stats-img"></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 db-right-content">
                <div className="main-content-inner">
                  <div className="profession-block d-flex justify-content-between">
                    <div className="total-communities order-1">
                      <div className="tc-title">
                        Lorem Ipsum <span>1000</span>
                      </div>
                      <div className="detail-btn text-start">
                        <button className="orange-filled-btn claimbtn">Details</button>
                      </div>
                      {/* <div className="tc-units-score d-flex gap-3">
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle orange-shade"></div>
                            <div className="score-details">
                              700 <span>Designation Wise</span>
                            </div>
                          </div>
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle gray-shade"></div>
                            <div className="score-details">
                              700 <span>Industry Wise</span>
                            </div>
                          </div>
                          <div></div>
                        </div> */}
                    </div>
                    <div className="tc-img order-2">
                      <img src={stats_img_two} alt="stats-img"></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 db-right-content">
                <div className="main-content-inner">
                  <div className="profession-block d-flex justify-content-between">
                    <div className="total-communities order-1">
                      <div className="tc-title">
                        Lorem Ipsum <span>1000</span>
                      </div>
                      <div className="detail-btn text-start">
                        <button className="orange-filled-btn claimbtn">Details</button>
                      </div>
                      {/* <div className="tc-units-score d-flex gap-3">
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle orange-shade"></div>
                            <div className="score-details">
                              700 <span>Designation Wise</span>
                            </div>
                          </div>
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle gray-shade"></div>
                            <div className="score-details">
                              700 <span>Industry Wise</span>
                            </div>
                          </div>
                          <div></div>
                        </div> */}
                    </div>
                    <div className="tc-img order-2">
                      <img src={stats_img_two} alt="stats-img"></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 db-right-content">
                <div className="main-content-inner">
                  <div className="profession-block d-flex justify-content-between">
                    <div className="total-communities order-1">
                      <div className="tc-title">
                        Lorem Ipsum <span>1000</span>
                      </div>
                      <div className="detail-btn text-start">
                        <button className="orange-filled-btn claimbtn">Details</button>
                      </div>
                      {/* <div className="tc-units-score d-flex gap-3">
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle orange-shade"></div>
                            <div className="score-details">
                              700 <span>Designation Wise</span>
                            </div>
                          </div>
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle gray-shade"></div>
                            <div className="score-details">
                              700 <span>Industry Wise</span>
                            </div>
                          </div>
                          <div></div>
                        </div> */}
                    </div>
                    <div className="tc-img order-2">
                      <img src={stats_img_two} alt="stats-img"></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 db-right-content">
                <div className="main-content-inner">
                  <div className="profession-block d-flex justify-content-between">
                    <div className="total-communities order-1">
                      <div className="tc-title">
                        Lorem Ipsum <span>1000</span>
                      </div>
                      <div className="detail-btn text-start">
                        <button className="orange-filled-btn claimbtn">Details</button>
                      </div>
                      {/* <div className="tc-units-score d-flex gap-3">
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle orange-shade"></div>
                            <div className="score-details">
                              700 <span>Designation Wise</span>
                            </div>
                          </div>
                          <div className="score-block d-flex justify-content-between">
                            <div className="lineargrad-circle gray-shade"></div>
                            <div className="score-details">
                              700 <span>Industry Wise</span>
                            </div>
                          </div>
                          <div></div>
                        </div> */}
                    </div>
                    <div className="tc-img order-2">
                      <img src={stats_img_two} alt="stats-img"></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="main-content-inner">
                  <div className="profession-block">
                    <h3 className="chart-title text-start">Lorem Ipsum</h3>
                    <div className="bar-graph">
                      <img src={graph_img} alt="graph"></img>
                    </div>
                  </div>
                </div>
              </div>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "25vh",
                  flexDirection: "column",
                  textAlign: "center",
                }}
              >
                {/* <Loader /> */}
                <Typography
                  variant="h5"
                  sx={{
                    marginTop: "20px",
                    color: "#333",
                  }}
                >
                  This feature is in progress. Please check back later.
                </Typography>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardpageComp;
